import ErLogo from 'assets/images/content/er-logo.svg';
import Zkh from 'assets/images/content/zkh-logo.png';
import MinLogo from 'assets/images/content/mins-rf-logo.svg';
import FondLogo from 'assets/images/content/fond-logo.svg';

export const Sponsor = () => {
    return (
        <section className='sponsor'>
            <div className='container'>
                <div className='sponsor__wrap'>
                    <div className='sponsor__block'>
                        <h3 className='sponsor__title text-s24'>Организатор</h3>
                        <div className='sponsor__row sponsor__row_first'>
                            <div className='sponsor__item sponsor__item_row'>
                                <div className='sponsor__logo'>
                                    <img src={ErLogo} alt='' />
                                </div>
                                <div className='sponsor__logo-text'>
                                    Всероссийская политическая <br /> партия
                                    «Единая&nbsp;Россия»
                                </div>
                            </div>
                            <div className='sponsor__item'>
                                <div className='sponsor__logo'>
                                    <img src={Zkh} alt='' />
                                </div>
                                <div className='sponsor__logo-text'>
										<span>
											Национальный центр общественного контроля в&nbsp;сфере ЖКХ
											«ЖКХ&nbsp;Контроль»
										</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sponsor__block'>
                        <h3 className='sponsor__title text-s24'>Партнеры</h3>
                        <div className='sponsor__row sponsor__row_second'>
                            <div className='sponsor__logo'>
                                <img src={MinLogo} alt='' />
                            </div>
                            <div className='sponsor__logo'>
                                <img src={FondLogo} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
